import { React, useState, useEffect } from 'react'
import { motion } from "framer-motion";
import { Helmet } from 'react-helmet'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserPen, faEnvelope, faCircleInfo, faCheck, faChevronRight } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../../components/MainHeader/MainHeader.js'
import MainFooter from '../../../components/MainFooter/MainFooter.js'
import CTAButton from '../../../components/CTAButton/CTAButton.js'
import Skeleton from '../../../components/Skeleton/Skeleton.js'

import { lP, boxvar2_1, boxvar4, URL_MAINAPI, API_TOKEN, capFirstChar, validateAddressFields, validateProfileBase, validateEmail } from '../../../main.js'

import '../../../main.css'
import './ProfilEdit.css'
import './MProfilEdit.css'

import Cookies from 'universal-cookie'

export default function ProfilEdit() {

    var [loadedUserData, setLoadedUserData] = useState(0)
    var [banner, setBanner] = useState(null)
    var [mailBanner, setMailBanner] = useState(null)
    var [showMailChange, setShowMailChange] = useState(0)
    var [userId, setUserId] = useState("")
    var [copiedUserId, setCopiedUserId] = useState(0)

    const cookies = new Cookies()
    let cur_authtoken = cookies.get('authtoken')

    var [formData, setFormData] = useState({
        formVorname: "",
        formNachname: "",
        formMail: "",
        formTel: "",
        formMobil: "",
        formAddressStreet: "",
        formAddressHnr: "",
        formAddressPlace: "",
        formAddressPLZ: "",
        formAddressAddon: "",
        formChannelSelect: 1,
        formBirthdate: "",
        formQualifications: "",
        formChbAGB: 0,
        formChbFotos: 0,
        formChbNewsletter: 0
    })

    var [formNewMail, setFormNewMail] = useState("")

    useEffect(() => {
        getUserData()
    }, [])

    function getUserData() {
        setLoadedUserData(0)
        try {
            fetch(URL_MAINAPI + "/user/me", {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    applyUserData(res.data)
                    setLoadedUserData(1)
                } else {
                    setLoadedUserData(-1)
                }
            }))
        } catch (err) {
            setLoadedUserData(-1)
        }
    }

    function applyUserData(u) {
        setUserId(u._id ? String(u._id) : "")
        setFormData({
            formVorname: u.firstname || "",
            formNachname: u.lastname || "",
            formMail: (u.contact && u.contact.email) || "",
            formTel: (u.contact && u.contact.tel) || "",
            formMobil: (u.contact && u.contact.mobile) || "",
            formAddressStreet: (u.address && u.address.street) || "",
            formAddressHnr: (u.address && u.address.nr != null) ? String(u.address.nr) : "",
            formAddressAddon: (u.address && u.address.addon) || "",
            // API speichert zipcode als Number — Inputs/Validierung brauchen String
            formAddressPLZ: (u.address && u.address.zipcode != null && u.address.zipcode !== "") ? String(u.address.zipcode) : "",
            formAddressPlace: (u.address && u.address.city) || "",
            formBirthdate: u.birthday ? String(u.birthday).slice(0, 10) : "",
            formQualifications: (u.additionalInfo && u.additionalInfo.qualifications) || "",
            formChannelSelect: Number((u.additionalInfo && u.additionalInfo.preferred_channel) || 1),
            formChbAGB: (u.agreements && u.agreements.agb_agreed) ? 1 : 0,
            formChbFotos: (u.agreements && u.agreements.photos_agreed) ? 1 : 0,
            formChbNewsletter: (u.agreements && u.agreements.newsletter_agreed) ? 1 : 0
        })
    }

    function copyUserId() {
        if (!userId) return
        try {
            navigator.clipboard.writeText(userId).then(() => {
                setCopiedUserId(1)
                setTimeout(() => setCopiedUserId(0), 2000)
            }).catch(() => { })
        } catch (err) { }
    }

    function setField(key, value) {
        setFormData({ ...formData, [key]: value })
    }

    function doSave() {
        setBanner(null)

        var baseCheck = validateProfileBase({
            firstname: formData.formVorname,
            lastname: formData.formNachname,
            tel: formData.formTel,
            mobile: formData.formMobil,
            qualifications: formData.formQualifications,
            preferred_channel: Number(formData.formChannelSelect),
            birthday: formData.formBirthdate
        })
        var addrCheck = validateAddressFields({
            nr: formData.formAddressHnr,
            street: formData.formAddressStreet,
            addon: formData.formAddressAddon,
            zipcode: formData.formAddressPLZ,
            city: formData.formAddressPlace
        })

        if (baseCheck.error != null || addrCheck.error != null) {
            setBanner({ type: "error", text: "Bitte überprüfe deine Eingaben. Alle Pflichtfelder müssen korrekt ausgefüllt sein." })
            return
        }

        setBanner({ type: "loading", text: "Änderungen werden gespeichert..." })

        var reqbody = {
            "firstname": formData.formVorname,
            "lastname": formData.formNachname,
            "contact": {
                "tel": formData.formTel,
                "mobile": formData.formMobil,
            },
            "address": {
                "nr": String(formData.formAddressHnr),
                "street": formData.formAddressStreet,
                "addon": formData.formAddressAddon,
                "zipcode": String(formData.formAddressPLZ),
                "city": formData.formAddressPlace
            },
            "birthday": new Date(formData.formBirthdate).toISOString(),
            "agreements": {
                "newsletter_agreed": formData.formChbNewsletter ? 1 : 0,
                "photos_agreed": formData.formChbFotos ? 1 : 0,
                "agb_agreed": formData.formChbAGB ? 1 : 0,
            },
            "additionalInfo": {
                "qualifications": formData.formQualifications,
                "preferred_channel": Number(formData.formChannelSelect)
            }
        }

        try {
            fetch(URL_MAINAPI + "/user/update", {
                method: "PATCH",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                body: JSON.stringify(reqbody),
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    cookies.set('firstname', formData.formVorname, { path: '/' })
                    cookies.set('lastname', formData.formNachname, { path: '/' })
                    setBanner({ type: "done", text: "Deine Änderungen wurden erfolgreich gespeichert." })
                } else {
                    setBanner({ type: "error", text: "Fehler beim Speichern: " + (res.data.error || "unbekannter Fehler") })
                }
            }))
        } catch (err) {
            setBanner({ type: "error", text: "Es gab einen Fehler bei der Verarbeitung: " + err })
        }
    }

    function doChangeMail() {
        setMailBanner(null)

        var mailCheck = validateEmail(formNewMail)
        if (mailCheck.error != null) {
            setMailBanner({ type: "error", text: "Bitte gib eine gültige neue E-Mail-Adresse ein." })
            return
        }

        setMailBanner({ type: "loading", text: "Anfrage wird gesendet..." })

        try {
            fetch(URL_MAINAPI + "/user/change-email", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                body: JSON.stringify({ "email": formNewMail }),
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    setMailBanner({ type: "done", text: "Bestätigungsmail an " + formNewMail + " gesendet. Bitte bestätige dort deine neue E-Mail-Adresse." })
                    setShowMailChange(0)
                } else {
                    setMailBanner({ type: "error", text: "Fehler: " + (res.data.error || "unbekannter Fehler") })
                }
            }))
        } catch (err) {
            setMailBanner({ type: "error", text: "Es gab einen Fehler bei der Verarbeitung: " + err })
        }
    }

    return (
        <div className='mainCon page' id='mainCon'>
            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Profil bearbeiten</title>
                <meta property="og:title" content="Profil bearbeiten" />
                <meta property="og:description" content="Persönliche Daten verwalten" />
                <meta name="robots" content="noindex" />
            </Helmet>

            <main className='page-body container section' style={{ paddingTop: '36px' }}>
                <div className='breadcrumb'>
                    <a href='/profil'>Profil</a>
                    <FontAwesomeIcon icon={faChevronRight} />
                    <span>Bearbeiten</span>
                </div>

                <motion.h1
                    variants={boxvar4}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-50px" }}
                    className='section-title'
                    style={{ marginBottom: '6px' }}
                >
                    ✏️ Profil bearbeiten
                </motion.h1>
                <p className='section-sub'>Verwalte hier deine persönlichen Daten.</p>

                {(loadedUserData == 0) ? (
                    <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} style={{ marginTop: '20px', maxWidth: '720px' }}>
                        <div className='card' style={{ padding: '26px 24px' }}>
                            <Skeleton width="40%" height={20} />
                            <Skeleton width="100%" height={16} />
                            <Skeleton width="100%" height={16} />
                            <Skeleton width="60%" height={16} />
                            <Skeleton width="35%" height={38} />
                        </div>
                    </motion.div>
                ) : (loadedUserData == -1) ? (
                    <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} style={{ marginTop: '20px' }}>
                        <div className='card profilerror-card'>
                            <h3>Deine Daten konnten nicht geladen werden.</h3>
                            <p>Bitte melde dich erneut an oder versuche es später noch einmal.</p>
                            <CTAButton variant="primary" hideArrow={false} title={"Zum Profil"} onclick={() => lP('/profil')} />
                        </div>
                    </motion.div>
                ) : (
                    <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} style={{ marginTop: '20px' }}>
                        <div className='card profiledit-card'>
                            <div className='profiledit-headline'>
                                <span className='profiledit-icon'><FontAwesomeIcon icon={faUserPen} /></span>
                                <h3>Persönliche Daten</h3>
                            </div>

                            <form>
                                <div className='profiledit-grid'>
                                    <div className="field">
                                        <label htmlFor="pe-vorname">Vorname</label>
                                        <input id="pe-vorname" type="text" maxLength="30" minLength="2" name="vorname" placeholder="Vorname" value={formData.formVorname} autoComplete='given-name' onInput={(e) => setField('formVorname', capFirstChar(e.target.value))}></input>
                                    </div>
                                    <div className="field">
                                        <label htmlFor="pe-nachname">Nachname</label>
                                        <input id="pe-nachname" type="text" maxLength="30" minLength="2" name="nachname" placeholder="Nachname" value={formData.formNachname} autoComplete='family-name' onInput={(e) => setField('formNachname', capFirstChar(e.target.value))}></input>
                                    </div>
                                    <div className="field">
                                        <label htmlFor="pe-geburtstag">Geburtsdatum</label>
                                        <input id="pe-geburtstag" type="date" name="geburtstag" placeholder="Geburtsdatum" value={formData.formBirthdate} autoComplete='bday' onInput={(e) => setField('formBirthdate', e.target.value)}></input>
                                    </div>
                                    <div className="field">
                                        <label htmlFor="pe-quali">Zusatzqualifikationen</label>
                                        <input id="pe-quali" type="text" maxLength="50" name="qualifications" placeholder="Qualifikationen (optional)" value={formData.formQualifications} onInput={(e) => setField('formQualifications', e.target.value)}></input>
                                    </div>
                                    <div className="field">
                                        <label htmlFor="pe-tel">Telefonnummer</label>
                                        <input id="pe-tel" type="tel" name="tel" placeholder="Telefonnummer" value={formData.formTel} autoComplete='tel' onInput={(e) => setField('formTel', e.target.value)}></input>
                                    </div>
                                    <div className="field">
                                        <label htmlFor="pe-mobil">Handynummer</label>
                                        <input id="pe-mobil" type="tel" name="mobil" placeholder="Mobilnummer (optional)" value={formData.formMobil} autoComplete='tel' onInput={(e) => setField('formMobil', e.target.value)}></input>
                                    </div>
                                </div>

                                <div className='profiledit-headline profiledit-headline-gap'>
                                    <span className='profiledit-icon'><FontAwesomeIcon icon={faEnvelope} /></span>
                                    <h3>Adresse</h3>
                                </div>

                                <div className='profiledit-grid'>
                                    <div className="field">
                                        <label htmlFor="pe-street">Straße</label>
                                        <input id="pe-street" type="text" maxLength="30" name="street" placeholder="Straße" value={formData.formAddressStreet} autoComplete='address-line1' onInput={(e) => setField('formAddressStreet', e.target.value)}></input>
                                    </div>
                                    <div className="field profiledit-narrow">
                                        <label htmlFor="pe-hnr">Haus-Nr.</label>
                                        <input id="pe-hnr" type="text" maxLength="10" name="hnr" placeholder="Nr." value={formData.formAddressHnr} autoComplete='address-line2' onInput={(e) => setField('formAddressHnr', e.target.value)}></input>
                                    </div>
                                    <div className="field profiledit-narrow">
                                        <label htmlFor="pe-plz">Postleitzahl</label>
                                        <input id="pe-plz" type="text" maxLength="5" minLength="4" name="plz" placeholder="PLZ" value={formData.formAddressPLZ} autoComplete='postal-code' onInput={(e) => setField('formAddressPLZ', e.target.value)}></input>
                                    </div>
                                    <div className="field">
                                        <label htmlFor="pe-ort">Wohnort</label>
                                        <input id="pe-ort" type="text" maxLength="30" name="ort" placeholder="Ort" value={formData.formAddressPlace} autoComplete='address-level2' onInput={(e) => setField('formAddressPlace', e.target.value)}></input>
                                    </div>
                                    <div className="field profiledit-full">
                                        <label htmlFor="pe-addon">Adresszusatz</label>
                                        <input id="pe-addon" type="text" maxLength="30" name="addon" placeholder="Adresszusatz (optional)" value={formData.formAddressAddon} onInput={(e) => setField('formAddressAddon', e.target.value)}></input>
                                    </div>
                                </div>

                                <div className="field">
                                    <label htmlFor="pe-channel">Informationskanal</label>
                                    <select id="pe-channel" className="in_channel" name="channel" value={formData.formChannelSelect} onChange={(e) => setField('formChannelSelect', e.target.value)}>
                                        <optgroup label="Wähle den Kanal">
                                            <option value="1">E-Mail</option>
                                            <option value="2">E-Mail & Post</option>
                                        </optgroup>
                                    </select>
                                </div>

                                <div className="field">
                                    <label className="chb_container">
                                        <input type="checkbox" className="checkbox" name="fotos_accepted" value="1" checked={formData.formChbFotos} onChange={(e) => setField('formChbFotos', e.target.checked ? 1 : 0)}></input>
                                        <span className="checkmark"></span>
                                        <div className='noselect'>Fotoaufnahmen im Rahmen aller angemeldeten Events erlauben (Optional)</div>
                                    </label>
                                    <label className="chb_container">
                                        <input type="checkbox" className="checkbox" name="newsletter_accepted" value="1" checked={formData.formChbNewsletter} onChange={(e) => setField('formChbNewsletter', e.target.checked ? 1 : 0)}></input>
                                        <span className="checkmark"></span>
                                        <div className='noselect'>Newsletter und Updates erhalten (Optional; Benachrichtigungen erhältst du immer)</div>
                                    </label>
                                </div>

                                {banner ? (
                                    <div className={'profiledit-banner profiledit-banner-' + banner.type} role={banner.type === 'error' ? 'alert' : 'status'}>
                                        <FontAwesomeIcon icon={faCircleInfo} /> {banner.text}
                                    </div>
                                ) : null}

                                <div className='profiledit-actions'>
                                    <CTAButton variant="primary" hideArrow={false} title={"Speichern"} onclick={() => doSave()} />
                                    <CTAButton variant="secondary" hideArrow={true} title={"Abbrechen"} onclick={() => lP('/profil')} />
                                </div>
                            </form>

                            <div className='profiledit-mail-block'>
                                <div className='profiledit-headline'>
                                    <span className='profiledit-icon'><FontAwesomeIcon icon={faEnvelope} /></span>
                                    <h3>E-Mail-Adresse</h3>
                                </div>
                                <p className='profiledit-mail-current'><b>Aktuelle E-Mail-Adresse:</b> {formData.formMail}</p>

                                {(!showMailChange) ? (
                                    <a href="#" className="action_third_a" onClick={(e) => { e.preventDefault(); setShowMailChange(1); setMailBanner(null) }}>E-Mail-Adresse ändern</a>
                                ) : (
                                    <div className='profiledit-mail-form'>
                                        <div className="field">
                                            <label htmlFor="pe-newmail">Neue E-Mail-Adresse</label>
                                            <input id="pe-newmail" type="email" name="newmail" placeholder="Neue E-Mail-Adresse" value={formNewMail} autoComplete='email' onInput={(e) => setFormNewMail(e.target.value)}></input>
                                        </div>
                                        <p className='profiledit-mail-hint'>
                                            Zur Bestätigung senden wir dir eine E-Mail an die neue Adresse. Deine alte E-Mail-Adresse bleibt aktiv, bis du die Änderung bestätigt hast.
                                        </p>
                                        <div className='profiledit-actions'>
                                            <CTAButton variant="primary" hideArrow={false} title={"Bestätigungsmail senden"} onclick={() => doChangeMail()} />
                                            <CTAButton variant="secondary" hideArrow={true} title={"Abbrechen"} onclick={() => { setShowMailChange(0); setMailBanner(null) }} />
                                        </div>
                                    </div>
                                )}

                                {mailBanner ? (
                                    <div className={'profiledit-banner profiledit-banner-' + mailBanner.type} role={mailBanner.type === 'error' ? 'alert' : 'status'}>
                                        <FontAwesomeIcon icon={(mailBanner.type === 'done') ? faCheck : faCircleInfo} /> {mailBanner.text}
                                    </div>
                                ) : null}
                            </div>

                            {userId ? (
                                <div className='profiledit-userid-block'>
                                    <button type="button" className='profiledit-userid-toggle' onClick={copyUserId} title="User-ID kopieren">
                                        <span className='profiledit-userid-label'>Technische User-ID</span>
                                        <code className='profiledit-userid-value'>{userId}</code>
                                        <span className='profiledit-userid-action'>{copiedUserId ? 'kopiert' : 'kopieren'}</span>
                                    </button>
                                    <p className='profiledit-userid-hint'>
                                        Nur nötig, wenn dich jemand als Organisations-Manager hinzufügen möchte. Gib deine User-ID nur an berechtigte Personen weiter.
                                    </p>
                                </div>
                            ) : null}
                        </div>
                        <br />
                        <p className='profile-hint'>
                            Bei Fragen oder sonstigen Anliegen wie beispielsweise Konto- bzw. Datenlöschung oder Auskünften nach DSGVO wende dich bitte an info@helferzeit.de
                        </p>
                    </motion.div>
                )}
            </main>

            <MainFooter useEventStyle={false} />
        </div>
    )
}
